import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { RotatingLines } from "react-loader-spinner";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../My Queues/queues.css";
import { MDBCard, MDBCardBody } from "mdb-react-ui-kit";
import { Modal } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const AllDocumentModel = (props) => {
  const { t } = useTranslation();

  const [zoom, setZoom] = useState(1);
  const [scale, setScale] = useState(1);

  const iframeContainerRef = useRef(null); // Ref to the container for zoom
  const handleZoomIn = () => {
    const container = iframeContainerRef.current;
    if (container) {
      const prevZoom = zoom;
       const newZoom = Math.min(prevZoom + 0.2, 5);
      setScale(newZoom)
      setZoom(newZoom);

      const zoomRatio = newZoom / prevZoom;

      container.scrollLeft =
        container.scrollLeft * zoomRatio +
        (container.clientWidth * (zoomRatio - 1)) / 2;
      container.scrollTop =
        container.scrollTop * zoomRatio +
        (container.clientHeight * (zoomRatio - 1)) / 2;
    }
  };

  const handleZoomOut = () => {
    const container = iframeContainerRef.current;
    if (container) {
      const prevZoom = zoom;
      const newZoom = Math.max(prevZoom - 0.2, 0.5);
      if(parseInt(newZoom)<=0){
      setScale(1)
      setZoom(1);
      }
      else{
        setScale(newZoom)
        setZoom(newZoom);
      }
      const zoomRatio = newZoom / prevZoom;

      container.scrollLeft =
        container.scrollLeft * zoomRatio +
        (container.clientWidth * (zoomRatio - 1)) / 2;
      container.scrollTop =
        container.scrollTop * zoomRatio +
        (container.clientHeight * (zoomRatio - 1)) / 2;
    }
  };

  return (
    <div>
      <Modal
        open={props.openModel}
        onClose={() => {
          props.handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="summaryModal doctor-summary doc-list-modal"
      >
        <MDBCard style={{ width: "100%", height: "100%", overflowY: "auto" }}>
          <MDBCardBody>
          {props?.docURL?.type?.split("/")[0] === "image" && (
              <div className="zoom-controls">
                <Button onClick={handleZoomOut} disabled={zoom <= 0.5}>
                  {t("Zoom Out")}
                </Button>
                <Button onClick={handleZoomIn} disabled={zoom >= 3}>
                  {t("Zoom In")}
                </Button>
              </div>
            )}
            <div className="doc-grid">
              {" "}
              <Button
                disabled={props.docIndex === 0 || props.loading}
                onClick={() => {
                  setZoom(1)
                  setScale(1)  
                  props.handlePreDoc()}
                }
                title={t("Previous")}
              >
                <i class="las la-angle-right"></i>
              </Button>
              {props.loading ? (
                <RotatingLines
                  strokeColor="grey"
                  strokeWidth="5"
                  animationDuration="0.75"
                  width="48"
                  visible={props.loading}
                />
              ) : (
                // <Button
                //   onClick={() => window.open(props.docURL.view, "_blank")}
                // >
                //   {" "}
                //   {t("View")}
                // </Button>
                <div className="document-iframe-grid"  
                ref={iframeContainerRef}
                style={{
                  height: "83vh",
                  position: "relative",
                  alignItems: props?.docURL?.type === "video/mp4" ?  "flex-start" : ""
                }}
              >
                {props?.docURL?.type === "pdf" ||
                props?.docURL?.type === "application/pdf" ? (
                  <iframe
                    src={props.docURL.view}
                    title="Document"
                    className="document-iframe"
                    id="myiFrame"
                  />
                ) : props?.docURL?.type === "video/mp4" ? (
                  <video
                    controls
                    className="document-iframe"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      display: "block",
                      margin: "0 auto",
                    }}
                  >
                    <source src={props.docURL.view} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <>
                  <div className="relative w-full  bg-gray-100" style={{width:"100%"}}>
                     <div
                      className="w-full h-full"
                      style={{
                        overflow: scale === 1 ? "auto" : "scroll",
                         maxWidth: "100%",
                        maxHeight: "73vh",
                        margin: "0px auto",
                        display: "block",
                        // scrollbarWidth: "thin",
                        // scrollbarColor: "#888 #f1f1f1",
                        direction: "ltr", // 👈 Force scrollbar to right
 
                      }}
                    >
                      <div
                        style={{
                          width: `${100 * scale}%`,
                          height: `${100 * scale}%`,
                          minWidth: "100%",
                          minHeight: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                         src={props.docURL.view}
                          alt="Zoomable document"
                          className="block select-none"
                           style={{
                        objectFit: "contain",
                        maxWidth: scale === 1 ? "100%" : "none",
                        maxHeight: scale === 1 ? "73vh" : "none", 
                        // width: scale === 1 ? "auto" : "100%",
                        width: "100%",
                        height: scale === 1 ? "auto" : "auto",
                        transformOrigin: "center center",
                      }}
                          draggable={false}
                        />
                      </div>
                    </div>

                  {/* Custom scrollbar styles */}
                  <style jsx>{`
                    div::-webkit-scrollbar {
                      width: 12px;
                      height: 12px;
                    }
                    div::-webkit-scrollbar-track {
                      background: #f1f1f1;
                      border-radius: 6px;
                    }
                    div::-webkit-scrollbar-thumb {
                      background: #888;
                      border-radius: 6px;
                    }
                    div::-webkit-scrollbar-thumb:hover {
                      background: #555;
                    }
                    div::-webkit-scrollbar-corner {
                      background: #f1f1f1;
                    }
                  `}</style>
                </div>
                  </>
                )}
              </div>
              )}
              <Button
                disabled={
                  props.documentLength - 1 === props.docIndex || props.loading
                }
                onClick={() => {
                  setZoom(1)
                  setScale(1)  
                  props.handleNextDoc()
              }}
                title={t("Next")}
              >
                <i class="las la-angle-left"></i>
              </Button>
            </div>
            <div className="doc-count">
              <h6>{`${props.docIndex + 1} מתוך ${props.documentLength}`}</h6>
              <Button
                sm="lg"
                className="buttton_content"
                onClick={() =>{
                   props.handleClose()}}
              >
                {" "}
                {t("Close")}
              </Button>
            </div>
          </MDBCardBody>
        </MDBCard>
      </Modal>
    </div>
  );
};

export default AllDocumentModel;
